// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pushRequestContainer[data-v-75b1abab]{width:100%;height:100%;display:flex;justify-content:center;align-items:center;background-color:#0085ff}.pushRequestContainer button[data-v-75b1abab]{color:#fff}.pushRequestContainer button.prompt[data-v-75b1abab]{padding:0 .5rem}.pushRequestContainer button.close[data-v-75b1abab]{padding-left:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
